import {
  DeleteOutlined,
  DownCircleFilled,
  EditOutlined,
  RollbackOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Table,
  Popconfirm,
  message,
  Input,
  Dropdown,
} from "antd";
import React, { useState } from "react";
import { getCurrentDateTimeInFormat } from "../../../helper/date_helper";
import DbConnectionModal from "./DbConnectionModal";

function DbConnections(props) {
  const [dataSource, setDataSource] = useState(props.initialData || []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    props.updateDbDataSource(newData);
  };

  const onAddClick = () => {
    setIsModalOpen(!isModalOpen);
  };
  const onModalClose = () => {
    setIsModalOpen(false);
  };
  const columns = [
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: "4%",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleDelete(record.key)}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
    {
      title: "Display Name",
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: "Database Type",
      dataIndex: "databaseType",
      key: "databaseType",
    },
    {
      title: "Host Name",
      dataIndex: "hostName",
      key: "hostName",
    },
    {
      title: "Port",
      dataIndex: "port",
      key: "port",
    },
    {
      title: "Database Name",
      dataIndex: "dbName",
      key: "dbName",
    },
  ];
  const updateTable = (formData) => {
    const displayNameExists = dataSource.some(
      (item) => item.displayName === formData.displayName
    );
    if (displayNameExists) {
      message.error("A record with this Display Name already exists.");
      return;
    }
    const updatedData = [...dataSource, { key: Date.now(), ...formData }];
    setDataSource(updatedData);
    props.updateDbDataSource(updatedData);
    setIsModalOpen(false);
  };

  return (
    <div>
      <Form form={form} component={false}>
        <Table
          dataSource={dataSource}
          columns={columns}
          rowClassName="editable-row"
          pagination={false}
        />
      </Form>
      <Button
        onClick={onAddClick}
        type="primary"
        style={{ marginBottom: 16, marginTop: 16 }}
      >
        Add Connection
      </Button>
      <DbConnectionModal
        isOpen={isModalOpen}
        onCancel={onModalClose}
        updateTable={updateTable}
      />
    </div>
  );
}

export default DbConnections;
